<template>
  <hsp-layout>
    <template v-slot:sidebar>
      <side-bar
        :background-color="sidebarBackground"
        short-title="HSP"
        title="HSP">
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'Report Links',
              icon: 'tim-icons icon-link-72',
              path: { name: linkName, params: linkParams }
            }">
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Add Link',
              icon: 'tim-icons icon-simple-add',
              path: { name: addLinkName, params: linkParams }
            }">
          </sidebar-item>
        </template>
      </side-bar>
    </template>
  </hsp-layout>
</template>
<script>
  import HspLayout from './HspLayout';

  export default {
    data() {
      return {
        modes: { default: 1, surveyId: 2, surveyUrlId: 3 },
        sidebarBackground: 'primary' //vue|blue|orange|green|red|primary,
      };
    },
    components: {
      HspLayout
    },
    computed: {
      mode() {
        return this.$route.params.surveyId && this.$route.params.surveyUrlId ? this.modes.surveyUrlId 
          : this.$route.params.surveyId ? this.modes.surveyId
          : this.modes.default;
      },
      linkName() {
        return this.mode === this.modes.surveyId ? "HspSurveyLinks"
          : this.mode === this.modes.surveyUrlId ? "InstanceLinks"
          : "Links";
      },
      addLinkName() {
        return this.mode === this.modes.surveyId ? "AddLinkHspSurvey"
          : this.mode === this.modes.surveyUrlId ? "AddLinkInstance"
          : "AddLink";
      },
      linkParams() {
        return this.mode === this.modes.surveyId ? { surveyId: this.$route.params.surveyId }
          : this.mode === this.modes.surveyUrlId ? { surveyUrlId: this.$route.params.surveyUrlId }
          : {};
      },
    },
  }
</script>
